import Footer from "../../FrontPage/components/Footer/Footer";
import Header from "../../FrontPage/components/Header/Header";
import TermsAndConditions from "../component/TermsConditions/TermsConditions";
const TermsConditionsPage = () => {
  return (
    <div>
      <Header />
      <TermsAndConditions />
      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
